import React from "react";

const KombuchaBottle = ({
    liquidColor = "#4CAF50",
    liquidColorLight = "#81C784",
    accentColor = "#FFB74D",
    bubbleColor = "rgba(255,255,255,0.6)",
    label = "KOMBUCHA",
    size = 300
}) => {
    const scale = size / 300;

    return (
        <svg
            width={size}
            height={size * 1.2}
            viewBox="0 0 300 360"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                {/* Gradient for liquid */}
                <linearGradient id={`liquidGrad-${label}`} x1="0%" y1="0%" x2="0%" y2="100%">
                    <stop offset="0%" stopColor={liquidColorLight} />
                    <stop offset="100%" stopColor={liquidColor} />
                </linearGradient>

                {/* Glass reflection gradient */}
                <linearGradient id={`glassGrad-${label}`} x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="rgba(255,255,255,0.3)" />
                    <stop offset="50%" stopColor="rgba(255,255,255,0.1)" />
                    <stop offset="100%" stopColor="rgba(255,255,255,0.2)" />
                </linearGradient>

                {/* Bottle shadow */}
                <filter id={`shadow-${label}`} x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="0" dy="4" stdDeviation="8" floodOpacity="0.3"/>
                </filter>
            </defs>

            {/* Bottle body */}
            <g filter={`url(#shadow-${label})`}>
                {/* Main bottle shape */}
                <path
                    d="M90 80 L90 60 Q90 40 110 40 L190 40 Q210 40 210 60 L210 80 Q230 100 230 130 L230 320 Q230 340 210 340 L90 340 Q70 340 70 320 L70 130 Q70 100 90 80 Z"
                    fill="rgba(200, 230, 210, 0.4)"
                    stroke="rgba(150, 200, 170, 0.6)"
                    strokeWidth="2"
                />

                {/* Liquid fill */}
                <path
                    d="M85 140 L85 315 Q85 330 100 330 L200 330 Q215 330 215 315 L215 140 Q215 130 200 130 L100 130 Q85 130 85 140 Z"
                    fill={`url(#liquidGrad-${label})`}
                />

                {/* Bubbles */}
                <circle cx="120" cy="280" r="6" fill={bubbleColor}>
                    <animate attributeName="cy" values="280;200;280" dur="3s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" values="0.6;0.2;0.6" dur="3s" repeatCount="indefinite"/>
                </circle>
                <circle cx="160" cy="300" r="4" fill={bubbleColor}>
                    <animate attributeName="cy" values="300;180;300" dur="4s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" values="0.5;0.1;0.5" dur="4s" repeatCount="indefinite"/>
                </circle>
                <circle cx="180" cy="260" r="5" fill={bubbleColor}>
                    <animate attributeName="cy" values="260;160;260" dur="3.5s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" values="0.7;0.2;0.7" dur="3.5s" repeatCount="indefinite"/>
                </circle>
                <circle cx="100" cy="240" r="3" fill={bubbleColor}>
                    <animate attributeName="cy" values="240;170;240" dur="2.8s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" values="0.6;0.15;0.6" dur="2.8s" repeatCount="indefinite"/>
                </circle>
                <circle cx="195" cy="290" r="4" fill={bubbleColor}>
                    <animate attributeName="cy" values="290;190;290" dur="3.2s" repeatCount="indefinite"/>
                    <animate attributeName="opacity" values="0.5;0.2;0.5" dur="3.2s" repeatCount="indefinite"/>
                </circle>

                {/* Glass reflection */}
                <path
                    d="M80 130 L80 320 Q80 335 95 335 L100 335 L100 130 Q100 120 90 125 Z"
                    fill={`url(#glassGrad-${label})`}
                />

                {/* Bottle cap */}
                <rect x="100" y="30" width="100" height="20" rx="4" fill="#2D2D2D"/>
                <rect x="105" y="25" width="90" height="10" rx="3" fill="#1A1A1A"/>

                {/* Label background */}
                <rect x="85" y="200" width="130" height="80" rx="4" fill="rgba(255,255,255,0.95)"/>
                <rect x="85" y="200" width="130" height="80" rx="4" fill="none" stroke={accentColor} strokeWidth="3"/>

                {/* Label accent stripe */}
                <rect x="85" y="200" width="130" height="20" fill={accentColor}/>

                {/* Label text */}
                <text x="150" y="215" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold" fontFamily="Arial">
                    BREWING CO
                </text>
                <text x="150" y="250" textAnchor="middle" fill={liquidColor} fontSize="14" fontWeight="bold" fontFamily="Arial">
                    {label}
                </text>
                <text x="150" y="268" textAnchor="middle" fill="#666" fontSize="9" fontFamily="Arial">
                    ORGANIC KOMBUCHA
                </text>

                {/* Small decorative elements on label */}
                <circle cx="100" cy="248" r="3" fill={accentColor}/>
                <circle cx="200" cy="248" r="3" fill={accentColor}/>
            </g>
        </svg>
    );
};

export default KombuchaBottle;
